import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

function createStyles(theme) {
  return {
    bordered: {
      borderBottom: `1px solid ${theme.palette.grey[100]}`,
    },
  };
}

export default function HeadingRow() {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Grid container direction="row-reverse">
      <Grid item xs={3}>
        <Typography
          variant="subtitle2"
          modifiers="fontWeightMedium"
          style={styles.bordered}
        >
          Supplied
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography
          variant="subtitle2"
          modifiers="fontWeightMedium"
          style={styles.bordered}
        >
          Agreed
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography
          variant="subtitle2"
          modifiers="fontWeightMedium"
          style={styles.bordered}
        >
          Requested
        </Typography>
      </Grid>
    </Grid>
  );
}
